import * as a from "react";
import i from "../lib/IconBase.es.js";
import e from "../defs/MagnifyingGlass.es.js";
const o = a.forwardRef((s, n) => /* @__PURE__ */ a.createElement(i, { ref: n, ...s, weights: e }));
o.displayName = "MagnifyingGlassIcon";
const f = o;
export {
  f as MagnifyingGlass,
  o as MagnifyingGlassIcon
};
